import { render, staticRenderFns } from "./StrokesNurseReviewed.vue?vue&type=template&id=107f8e91&"
import script from "./StrokesNurseReviewed.vue?vue&type=script&lang=ts&"
export * from "./StrokesNurseReviewed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('107f8e91')) {
      api.createRecord('107f8e91', component.options)
    } else {
      api.reload('107f8e91', component.options)
    }
    module.hot.accept("./StrokesNurseReviewed.vue?vue&type=template&id=107f8e91&", function () {
      api.rerender('107f8e91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-viz/v2/StrokesNurseReviewed.vue"
export default component.exports